import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { endpoint: String }

  emailBlur(event) {
    const email = event.target.value.trim()
    if (!this.isValidEmail(email)) return

    fetch(this.endpointValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": this.csrfToken()
      },
      body: JSON.stringify({ email })
    }).catch(() => { /* silent — best-effort */ })
  }

  isValidEmail(s) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s)
  }

  csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content
  }
}
